//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import(/* webpackChunkName: "herb" */ './indexAppl');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/gypsum/v2025/indexAppl',
      name: 'gypsum_v2025_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/gypsum/v2025/indexAdmin',
      name: 'gypsum_v2025_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/gypsum/v2025/edit',
      name: 'gypsum_v2025_edit',
      component: edit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/gypsum/v2025/router.js